import { journeyVariants } from "../views/journey/variants";

/**
 * Registro central de variantes de diseño por vista.
 *
 * PARADIGMA (demo iterativa): una vista puede ofrecer varias alternativas de
 * disposicion / forma de los graficos para enseñar en las revisiones "¿asi o
 * asa?" sin tocar codigo. Se cambia en vivo con el VariantSwitcher y la eleccion
 * queda en la URL (compartible). En la version final se deja una y se apaga el
 * panel con SHOW_VARIANT_SWITCHER = false.
 *
 * Ahora mismo solo Fuga por fase tiene variantes (embudo / camino), con el
 * selector en la esquina del propio grafico.
 */
export const viewVariants = {
    journey: journeyVariants,
};

/** Interruptor global del panel flotante. Desactivado: el selector vive en el grafico. */
export const SHOW_VARIANT_SWITCHER = false;

/** Variantes registradas para una vista (array vacio si no tiene). */
export const getVariants = (viewKey) => viewVariants[viewKey] || [];
